<div class="quote-breakdown-section">
  <div class="quote-breakdown-section__product">
    <div class="quote-breakdown-section__product__title"><ng-content select="product"></ng-content></div>
    <div class="quote-breakdown-section__product__info"><ng-content></ng-content></div>
  </div>
  <div class="quote-breakdown-section__price">
    <div class="quote-breakdown-section__price__price" *ngIf="!(price() | lxEqual : endPrice())">
      {{ price() | lxPrice : { currency: currency() } }}
    </div>
    <div class="quote-breakdown-section__price__end-price">
      {{ endPrice() | lxPrice : { currency: currency() } }}
    </div>
  </div>
</div>
